/* eslint-disable */
import { lista, nao_autorizado, pegaDados, processar } from '../../services/GenericAPI';
import { Parametro } from '../../models/parametro'; // Modelo da tabela Parametro
import { Filtro } from "../../models/filtro/filtro";
import { BaseDescSCH, getBaseSCH } from "../../search/BaseSCH";

const url = '/parametros';

const state = {
   all: [],
   allList: [],
   parametro: new Parametro(),
   filtro: new Filtro()
};

const getters = {
   listaAllParametros: (state) => {
      return state.allList;
   },
   listaParametros: (state) => {
      return state.all;
   },
   pegaParametro: (state) => {
      return state.parametro;
   },
   pegaFiltro: (state) => {
      return state.filtro;
   }
};

const actions = {
   searchItem({ commit }, search) {
      state.filtro.filters.search = [];
      state.filtro.filters.addSearch(['descr'], '%' + search + '%', 'ilike');
   },
   async getItem({ commit }, { parametro_id, onSucesso, onErro }) {
      try {
         var filtro = getBaseSCH('parametro_id', parametro_id, '=');
         const list = (await pegaDados(url + '/get', filtro)).data;
         if (list.data[0] !== undefined) {
            commit('SET_PARAMETRO', list.data[0]);
            onSucesso();
         } else {
            onErro();
         }
      } catch (error) {
         onErro();
         console.log(error);
      }
   },
   setFiltro({ commit }, perPage) {
      commit('SET_FILTRO', BaseDescSCH(perPage));
   },
   async setAllListParametros({ commit }, { onSucesso, onErro }) {
      try {
         const list = (await lista(url + '/all')).data;
         commit('SET_ALL_LIST', list);
         onSucesso();
      } catch (error) {
         console.log(error);
         onErro();
      }
   },
   async setAllParametros({ commit }, { onSucesso, onErro }) {
      try {
         const list = (await pegaDados(url + '/get', state.filtro)).data;
         commit('SET_PARAMETROS', list);
         onSucesso();
      } catch (error) {
         console.log(error);
         onErro();
         nao_autorizado(error);
      }
   },
   async processarParametro({ commit }, { acao, onSucesso, onErro }) {
      try {
         let res = await processar(url + (acao === 'gravar' ? '/commit' : '/delete'), state.parametro, acao);
         this.dispatch('geral/setMsgSuccess', res.data.message);
         onSucesso();
      } catch (error)      {
         onErro();
         console.log('error: ', error);
         this.dispatch('geral/setObjMsgError', error.response.data);
      }
   },
   setParametro({ commit }, parametro) {
      commit('SET_PARAMETRO', parametro);
   }
};

const mutations = {
   SET_ALL_LIST(state, filtro) {
      state.allList = filtro;
   },
   SET_FILTRO(state, filtro) {
      state.filtro = filtro;
   },
   SET_PARAMETROS(state, parametros) {
      state.all = parametros;
   },
   SET_PARAMETRO(state, parametro) {
      state.parametro = parametro;
   }
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
};
